// extracted by mini-css-extract-plugin
module.exports = {"firstKv":"FirstKv_firstKv__hhzDK","ef-box":"FirstKv_ef-box__98lp3"};